import { Injectable } from '@angular/core';
import { Service, ServiceCountingMethods, ServiceDependsOn, Transport } from './service.model';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class ServiceService {
	editable = false;
	data = this.cleanData();
	mockData = this.cleanMockData();
	limits = false;
	dataLoaded$: Subject<void> = new Subject();

	cleanData(): Service {
		return {
			id: 0,
			name: '',
			code: '',
			isActive: false,
			description: '',
			serviceMultimedias: [],
			kinds: [],
			mandatory: false,
			countingMethod: '',
			allParticipant: false,
			personTypes: [],
			note: '',
			methodValue: 0,
			serviceRules: [],
			serviceType: null,
			sell: { lower: null, upper: null },
			departures: { lower: null, upper: null },
			sellChannels: [],
			transport: null,
			amount: 0,
			availableDaysBeforeDeparture: 0,
			dependsOn: '',
			insurer: null,
		};
	}

	cleanMockData() {
		return {
			products: null,
			product_whitelist: null,
			product_blacklist: null,
			locations: null,
			location_whitelist: null,
			location_blacklist: null,
			count_services_blacklist: null,
			count_services_whitelist: null,
			services: null,
			services_blacklist: null,
			services_whitelist: null,
			service_type: null,
			sell: null,
			note: null,
			departures: null,
			kinds: null,
			channels: null,
			multimedias: null,
			person_types: null,
			count: [
				{ enum: ServiceDependsOn.SLOT, name: 'Uczestnik' },
				{ enum: ServiceDependsOn.DAY, name: 'Dzień' },
				{ enum: ServiceDependsOn.NIGHTS_STAY, name: 'Liczba nocy' },
			],
			method: [
				{ enum: ServiceCountingMethods.VALUE, name: 'Wartość' },
				{ enum: ServiceCountingMethods.PERMILLE, name: 'Procent' },
				{ enum: ServiceCountingMethods.CUSTOM, name: 'Brak' },
			],
			transport: [
				{ enum: Transport.ALL, name: 'Wszystkie' },
				{ enum: Transport.BUS, name: 'Autokar' },
				{ enum: Transport.FLY, name: 'Lot' },
				{ enum: Transport.OWN_TRANSPORT, name: 'Dojazd Własny' },
			],
		};
	}

	resetData() {
		this.data = this.cleanData();
		this.mockData = this.cleanMockData();
	}
}
